import React, { useEffect, useState } from "react";
import axios from "axios";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie"; 
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import "../Modal/Modal.css";
import { toast } from "react-toastify";

export default function HomepageClassEditModal({ ids , cancle }) {
    const [classId, setClassId] = useState("");
     const [cookies, setCookie, removeCookie] = useCookies();


    async function editHandle() {
        const url = Constants.apiUrl + "/api/homepage/set-class";
        axios.post(url, {
            id: ids,
            class_id: classId
        }, {
            headers: {
                Authorization: "Bearer " + cookies.user_server_token,
            },
        })
            .then((r) => {
                toast.success("ویرایش با موفقیت انجام شد");
                cancle();
            })
            .catch((e) => {
                toast.error("خطا در ویرایش");
            });
    }

    return (
        <React.Fragment>

            <div className="location_modal text-right">
                <div className="location_modal_box">
                    <div className="location_modal_header bg-dark p-2">
                        <span className=" w-100 text-right text-white">ویرایش</span>
                    </div>
                    <div className="p-4 text-center">
                        <p>
                            شناسه کلاس
                        </p>
                        <input type="text" className="form-control" value={classId} onChange={(e)=>{setClassId(e.target.value)}} />
                        <hr />
                        <div className="row text-right my-3 " style={{ direction: "rtl" }}>
                            <div className="col-12 text-center">
                            <button className="btn btn-success btn-block" onClick={editHandle} >ویرایش</button>
                            <button className="btn btn-danger btn-block"  onClick={cancle}>انصراف</button>
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </React.Fragment>
    )
}